import { useContext } from "react";
import styles from "../DeleteStore/DeleteStoreModal.module.css";
import { deleteUserFromDatabase } from '../../../hooks/User';
import { UserContext } from '../../../context/UserContext';
import { handleUserRole } from '../../../utils/UserRole'

function Modal({ closeModal }) {
  const { 
    selectedUser, 
    setIsDeletedUser,
    clearSuccess
   } = useContext(UserContext);

  const deleteUser = async () => {
    if(selectedUser != null) {
      console.log("selectedUser", selectedUser)
        try {
          const response = await deleteUserFromDatabase( selectedUser.id ); 
          if (response) {
            setIsDeletedUser(true)
            closeModal()
          } else {
            setIsDeletedUser(false)
            console.error("Failed to delete user.");
          }
      } catch (error) {
        setIsDeletedUser(false)
          console.error("Error fetching user:", error);
      }
    }
  }
  return (
    <div className={styles.modalBackground}>
      <div className={styles.modalContainer}>
        <div className={styles.content}>
            <h1>Deseja excluir o usuário selecionado?</h1>
            <p>{"Id: "+selectedUser?.id}</p>
            <p>{"Nome: "+selectedUser?.name}</p>
            <p>{"Login: "+selectedUser?.username}</p>
            <p>{"Função: "+ handleUserRole(selectedUser?.role)}</p>
            <p>{"Telefone: "+selectedUser?.phone}</p>
            {/* <p>{"Loja: "+selectedUser?.store?.name}</p> */}
        </div>
        <div className={styles.buttonContent}>
          <button className={styles.buttonConfirm} onClick={ deleteUser }>Deletar</button>
          <button onClick={ closeModal } className={styles.buttonCancel}>Cancelar</button>
        </div>
      </div>
    </div>
  );
}

export default Modal;
